/**
 * Normalizes any phone number by:
 * - Removing non-digit characters
 * - Replacing "00" with an international prefix (like "+")
 * - Returning a digit-only string (no "+" — compatible with react-phone-input-2)
 */
export function normalizePhoneNumber(input?: string | null): string {
    if (!input) return '';
    
     // Remove all non-digit characters
    const digitsOnly = input.replace(/\D/g, '');
  
    // Replace leading "00" with empty string to simulate "+"
    if (digitsOnly.startsWith('00')) {
      return digitsOnly.slice(2);
    }
  
    return digitsOnly;
  }